import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import StoreLogo from "@/components/StoreLogo";
import { fetchCoupons } from "@/lib/api";

const FEATURED_STORES = [
  { name: "Netflix", url: "https://www.netflix.com" },
  { name: "Spotify", url: "https://www.spotify.com/us" },
  { name: "Disney+", url: "https://www.disneyplus.com" },
  { name: "HBO Max", url: "https://www.max.com" },
  { name: "Hulu", url: "https://www.hulu.com" },
  { name: "Peacock", url: "https://www.peacocktv.com" },
  { name: "YouTube Premium", url: "https://www.youtube.com/premium" },
  { name: "Apple TV+", url: "https://tv.apple.com" },
  { name: "Audible", url: "https://www.audible.com" },
  { name: "Paramount+", url: "https://www.paramountplus.com" },
  { name: "NordVPN", url: "https://nordvpn.com" },
  { name: "Canva", url: "https://www.canva.com" },
  { name: "Adobe Creative Cloud", url: "https://www.adobe.com/creativecloud.html" },
  { name: "Microsoft 365", url: "https://www.microsoft.com/microsoft-365" },
  { name: "ChatGPT Plus", url: "https://chat.openai.com" },
  { name: "Xbox Game Pass", url: "https://www.xbox.com/xbox-game-pass" },
];

export default function FeaturedApps() {
  const navigate = useNavigate();
  const [previews, setPreviews] = useState({});

  useEffect(() => {
    (async () => {
      const results = await Promise.all(
        FEATURED_STORES.map((s) =>
          fetchCoupons({ store: s.name, limit: 1 }).catch(() => [])
        )
      );
      const map = {};
      results.forEach((arr, i) => {
        if (arr[0]) map[FEATURED_STORES[i].name] = arr[0].discount_label;
      });
      setPreviews(map);
    })();
  }, []);

  return (
    <section
      className="mb-8 border-2 border-[#2d2a32] rounded-2xl p-5 bg-white hard-shadow-sm"
      data-testid="featured-apps-section"
    >
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="serif text-2xl md:text-3xl tracking-tight">
          Trending subscriptions
        </h2>
        <span className="text-[10px] tracking-[0.25em] text-[#5c5c5c] font-semibold">
          HANDPICKED
        </span>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1">
        {FEATURED_STORES.map((s) => (
          <button
            key={s.name}
            onClick={() => navigate(`/?store=${encodeURIComponent(s.name)}`)}
            data-testid={`featured-app-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="flex flex-col items-center gap-2 shrink-0 w-24 group"
          >
            <StoreLogo store={s.name} storeUrl={s.url} size={64} />
            <span className="text-[11px] font-semibold text-[#2d2a32] text-center leading-tight group-hover:text-[#ff6b6b]">
              {s.name}
            </span>
            {previews[s.name] && (
              <span className="text-[9px] tracking-wider font-bold text-[#ff6b6b] px-1.5 py-0.5 border border-[#ff6b6b] rounded">
                {previews[s.name]}
              </span>
            )}
          </button>
        ))}
      </div>
    </section>
  );
}
